/**
 * Report Management Endpoints
 */
export const REPORT_ENDPOINTS = {
  // Get available reports for dropdown
  getReport: 'report/get-report',
  
  // Generate target achievement report
  getTargetAchievementReport: 'report/get-target-achievement-report',
  
  // List all reports
  listAllReports: 'report/list-all-reports',
} as const;
